module.exports = __webpack_public_path__ + "fonts/Inter-600-cyrillic40.fbe36d9.woff2";